export const REQUEST_CASINO_CONTROLS = 'casinoControls/REQUEST_CASINO_CONTROLS';
export const SET_CASINO_CONTROLS = 'casinoControls/SET_CASINO_CONTROLS';
export const SET_CASINO_CONTROLS_ERRORS = 'casinoControls/SET_CASINO_CONTROLS_ERRORS';
export const CLEAR_CASINO_CONTROLS_ERRORS = 'casinoControls/CLEAR_CASINO_CONTROLS_ERRORS';

export const UPDATE_CASINO_LOSS_LIMIT = 'casinoControls/UPDATE_CASINO_LOSS_LIMIT';
export const UPDATE_CASINO_LOSS_LIMIT_SUCCESS = 'casinoControls/UPDATE_CASINO_LOSS_LIMIT_SUCCESS';
export const UPDATE_CASINO_LOSS_LIMIT_ERROR = 'casinoControls/UPDATE_CASINO_LOSS_LIMIT_ERROR';

export const UPDATE_CASINO_REALITY_CHECK = 'casinoControls/UPDATE_CASINO_REALITY_CHECK';
export const UPDATE_CASINO_REALITY_CHECK_SUCCESS = 'casinoControls/UPDATE_CASINO_REALITY_CHECK_SUCCESS';
export const UPDATE_CASINO_REALITY_CHECK_ERROR = 'casinoControls/UPDATE_CASINO_REALITY_CHECK_ERROR';


export const requestCasinoControls = () => ({ type: REQUEST_CASINO_CONTROLS });

export const setCasinoControls = (payload) => ({
  type: SET_CASINO_CONTROLS,
  payload
});

export const setCasinoControlsErrors = (errors) => ({
  type: SET_CASINO_CONTROLS_ERRORS,
  payload: errors
});

export const clearCasinoControlsErrors = () => ({ type: CLEAR_CASINO_CONTROLS_ERRORS });

export const updateCasinoLossLimit = (payload) => ({
  type: UPDATE_CASINO_LOSS_LIMIT,
  payload
});

export const updateCasinoLossLimitSuccess = (payload) => ({
  type: UPDATE_CASINO_LOSS_LIMIT_SUCCESS,
  payload
});

export const updateCasinoLossLimitErrors = (errors) => ({
  type: UPDATE_CASINO_LOSS_LIMIT_ERROR,
  payload: errors
});

export const updateCasinoRealityCheck = (payload) => ({
  type: UPDATE_CASINO_REALITY_CHECK,
  payload
});

export const updateCasinoRealityCheckSuccess = (payload) => ({
  type: UPDATE_CASINO_REALITY_CHECK_SUCCESS,
  payload
});

export const updateCasinoRealityCheckErrors = (errors) => ({
  type: UPDATE_CASINO_REALITY_CHECK_ERROR,
  payload: errors
});
